import list from './list'

const checkIsSupported = (userAgent: string) => list.test(userAgent)

export { list, checkIsSupported }